import { render, staticRenderFns } from "./data-specs-form-items.vue?vue&type=template&id=1cd0f942&scoped=true&"
import script from "./data-specs-form-items.vue?vue&type=script&lang=ts&"
export * from "./data-specs-form-items.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd0f942",
  null
  
)

export default component.exports